export default "__VITE_ASSET__540057d8__"